import { http } from './httpClient';

export async function listRoles(opts = {}) {
  const result = await http.get('/roles', opts);
  return result.data;
}

export async function getRole(id, opts = {}) {
  const result = await http.get(`/roles/${encodeURIComponent(id)}`, opts);
  return result.data;
}

export async function createRole(data, opts = {}) {
  const result = await http.post('/roles', data, opts);
  return result.data;
}

export async function updateRole(id, patch, opts = {}) {
  const result = await http.patch(`/roles/${encodeURIComponent(id)}`, patch, opts);
  return result.data;
}

export async function deleteRole(id, opts = {}) {
  await http.delete(`/roles/${encodeURIComponent(id)}`, opts);
}
